"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasDocumentMode = exports.HasMSInputMethodContext = void 0;
// This function checks if the browser has the MSInputMethodContext method.
// This method, as at Oct 2018 is supported only in IE11 and is then one  way to identify IE11.
// Ref: https://msdn.microsoft.com/library/dn433247
function HasMSInputMethodContext() {
    return !!window.MSInputMethodContext;
}
exports.HasMSInputMethodContext = HasMSInputMethodContext;
// This function checks if the browser has the documentMode attribute.
// This method, as at Oct 2018 is supported only in IE11 and is then one  way to identify IE11.
// Ref: https://msdn.microsoft.com/library/dn433247
function HasDocumentMode() {
    return !!document.documentMode;
}
exports.HasDocumentMode = HasDocumentMode;
